import { render, staticRenderFns } from "./AlertInstanceOverlay.vue?vue&type=template&id=22ef1070"
import script from "./AlertInstanceOverlay.vue?vue&type=script&lang=js"
export * from "./AlertInstanceOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports